// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { b3 as _b3 } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the b3 chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 8333
 * Chain Name: B3
 * Default Block Explorer: https://explorer.b3.fun
 * Default RPC URL: https://mainnet-rpc.b3.fun/http
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { b3 } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: b3,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const b3 = createCommon({
	..._b3,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
